<template>
  <div>
    <div class="innerItem">
      <div class="innerTitle setLabel withSelect">
        {{locale.footer}}
        <select v-model="footerLang" class="input inlineInput">
          <option v-for="lang in usableList" :key="lang.c" :value="lang.c">{{langName(lang.c)}}</option>
        </select>
        <span class="stkr stkrGrey">{{locale[responsive]}}</span>
      </div>
      <div class="flexBox mb15">
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_color_footerbg}}</span>
          <ColorPicker class="mt5" :target="'footerBg'" :color="colors.footerBg" />
        </div>
        <div class="flexInner">
          <span class="label toCapitalize colorGrey">{{locale.setting_color_footertext}}</span>
          <ColorPicker class="mt5" :target="'footerText'" :color="colors.footerText" />
        </div>
      </div>
      <div :style="setStyle" class="footerCopyright">
        <CITEditor
          :model="footer.copyright"
          :toolbarOption="textOption"
          :lang="footerLang"
          @blur="setLangValue" />
      </div>
      <!-- <div :style="setStyle" class="footerCopyright">
        <ckeditor :editor="editor"
          :config="configFooter"
          :value="footer.copyright[footerLang]"
          @input="updateValue"
          @blur="setLangValue">
        </ckeditor>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ColorPicker from '@/components/Util/ColorPicker.vue'
import CITEditor from '@/components/CITEditor/Index.vue'
import UTIL from '@/common/util'

export default {
  name: 'Footer',
  props: [
    'locale',
    'lang',
    'colors',
    'footer',
    'responsive'
  ],
  components: {
    ColorPicker,
    CITEditor
  },
  computed: {
    ...mapGetters({
      fontFamily: 'setting/getFonts'
    }),
    setFont: {
      get () {
        return this.$store.getters['setting/getFonts']
      },
      set (fonts) {
        this.configFooter.fontFamily.options = fonts
      }
    },
    configFooter () {
      return {
        placeholder: 'copyright here',
        extraPlugins: [ 'Font' ],
        fontFamily: { options: this.fontFamily },
        fontSize: { options: this.fontSize },
        alignment: { value: 'center' },
        toolbar: [
          'bold', 'italic', 'Underline', 'Strikethrough',
          '|',
          'fontSize', 'fontFamily',
          '|',
          'alignment',
          '|',
          'fontColor', 'fontBackgroundColor'
        ]
      }
    },
    usableList () {
      return this.lang.info.filter(x => x.u)
    },
    setStyle () {
      return {
        'background-color': this.colors.footerBg,
        'color': this.colors.footerText
      }
    }
  },
  watch: {
    footerLang (lang) {
      this.$store.commit('preview/setLang', lang)
    }
  },
  data () {
    return {
      textOption: [
        'Bold', 'Italic', 'Underline', 'Strikethrough',
        'FontSize', 'FontFamily',
        'Color', 'BackgroundColor',
        'TextAlign'
      ],
      fontSize: [
        10,
        11,
        'default',
        13,
        14
      ],
      footerLang: this.lang.default
    }
  },
  methods: {
    langName (c) {
      const code = `lang_${c}`
      return this.locale[code]
    },
    setLangValue () {
      const langObj = this.footer.copyright
      const value = this.footer.copyright[this.footerLang]
      const fillValue = UTIL.fillLangs(langObj, value)
      const Store = this.$store
      Object.keys(fillValue).forEach(function (lang) {
        const data = {
          lang: lang,
          value: fillValue[lang]
        }
        Store.commit('setting/setFooterCopyright', data)
      })
    },
    updateValue (value) {
      this.setLangValue()
      const data = {
        lang: this.footerLang,
        value: value
      }
      this.$store.commit('setting/setFooterCopyright', data)
    }
  }
}
</script>
